import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { SpinnerDotted } from 'spinners-react';
import envValues from '../../enviornment';
import { getCookies } from '../../hooks/useCookies';

function liftTrackerComponent() {
  const { userId } = useParams();

  const token = `Bearer ${getCookies('Token')}`;

  const [bodyData, setBodyData] = useState([]);
  const [filter, setFilter] = useState('weekly');
  const [body, setBody] = useState('Neck');
  // const [overviewData, setOverviewData] = useState();
  const [liftTrackerData, setLiftTrackerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getBodyData = async () => {
    try {
      const response = await axios.get(`${envValues.REACT_APP_API_ENDPOINT}/body-admin`);

      setBodyData(response.data.data);
    } catch (error) {
      console.log(error, 'err innn');
    }
  };

  const getLiftTrackerData = async (selectedFilter) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/lift-tracker/${userId}?filter=${selectedFilter}&bodyName=${body}`,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      // setOverviewData(response.data.data.liftTracker);

      setLiftTrackerData(response.data.data.exerciseHighLights.exercises);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLiftTrackerData(filter);
  }, [filter, body]);
  useEffect(() => {
    getBodyData();
  }, []);

  return (
    <div>
      {' '}
      <div className="inner_tab_head">
        <Tabs
          defaultActiveKey="weekly"
          id="justify-tab-example"
          className="mb-3"
          justify
          onSelect={(key) => key && setFilter(key)}
        >
          <Tab eventKey="weekly" title="Week">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                >
                  {bodyData.map((bodyItem) => (
                    <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                      {bodyItem.bodyName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  {/* <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                          <h6>
                            <span>Associated Muscles:</span>{' '}
                            {overviewData?.muscleGroups?.length > 0
                              ? overviewData.muscleGroups.join(', ')
                              : 'No data available'}
                          </h6>
                        </div>

                        <div className="d-flex justify-content-between gap-2 boxsec">
                          <div className="box">
                            <h5>Total Sets</h5>
                            <p>{overviewData?.data?.totalSets}</p>
                          </div>
                          <div className="box">
                            <h5>Average Primary Reps</h5>
                            <p>{overviewData?.data?.avgPrimaryReps?.toFixed(2)}</p>
                          </div>
                          <div className="box box3">
                            <h5>Average Reps Per Set</h5>
                            <p>{overviewData?.data?.avgReps?.toFixed(2)}</p>
                          </div>
                          <div className="box box4">
                            <h5>Average Secondary Reps</h5>
                            <p>{overviewData?.data?.avgSecondaryReps?.toFixed(2)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <Table responsive>
                    <thead>
                      <tr>
                        <th width="200px">Exercise</th>
                        <th>Sets</th>
                      </tr>
                    </thead>
                    <tbody>
                      {liftTrackerData?.map((item) => (
                        <tr>
                          <td>{item.exerciseName}</td>
                          <td>{item.totalSets}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </Tab>
          <Tab eventKey="monthly" title="Month">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                >
                  {bodyData.map((bodyItem) => (
                    <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                      {bodyItem.bodyName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  {/* <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                          <h6>
                            <span>Associated Muscles:</span>{' '}
                            {overviewData?.muscleGroups?.length > 0
                              ? overviewData.muscleGroups.join(', ')
                              : 'No data available'}
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.data?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Primary Reps</h5>
                          <p>{overviewData?.data?.avgPrimaryReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.data?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Secondary Reps</h5>
                          <p>{overviewData?.data?.avgSecondaryReps?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <Table responsive>
                    <thead>
                      <tr>
                        <th width="200px">Exercise</th>
                        <th>Sets</th>
                      </tr>
                    </thead>
                    <tbody>
                      {liftTrackerData?.map((item) => (
                        <tr>
                          <td>{item.exerciseName}</td>
                          <td>{item.totalSets}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </Tab>
          <Tab eventKey="yearly" title="Year">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                >
                  {bodyData.map((bodyItem) => (
                    <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                      {bodyItem.bodyName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  {/* <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                          <h6>
                            <span>Associated Muscles:</span>{' '}
                            {overviewData?.muscleGroups?.length > 0
                              ? overviewData.muscleGroups.join(', ')
                              : 'No data available'}
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.data?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Primary Reps</h5>
                          <p>{overviewData?.data?.avgPrimaryReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.data?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Secondary Reps</h5>
                          <p>{overviewData?.data?.avgSecondaryReps?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <Table responsive>
                    <thead>
                      <tr>
                        <th width="200px">Exercise</th>
                        <th>Sets</th>
                      </tr>
                    </thead>
                    <tbody>
                      {liftTrackerData?.map((item) => (
                        <tr>
                          <td>{item.exerciseName}</td>
                          <td>{item.totalSets}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </Tab>
          <Tab eventKey="all" title="Lifetime">
            <div className="resp_table">
              <div className="table_select">
                <Form.Select
                  aria-label="Select Body Part"
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                >
                  {bodyData.map((bodyItem) => (
                    <option key={bodyItem.bodyName} value={bodyItem.bodyName}>
                      {bodyItem.bodyName}
                    </option>
                  ))}
                </Form.Select>
              </div>
              {isLoading ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '50vh',
                  }}
                >
                  <SpinnerDotted style={{ color: '#207a4a' }} />
                </div>
              ) : (
                <>
                  {/* <div className="overview_outer">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <h3>Overview</h3>
                          <h6>
                            <span>Associated Muscles:</span>{' '}
                            {overviewData?.muscleGroups?.length > 0
                              ? overviewData.muscleGroups.join(', ')
                              : 'No data available'}
                          </h6>
                        </div>
                        <div className="col-md-3">
                          <h5>Total Sets</h5>
                          <p>{overviewData?.data?.totalSets}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Primary Reps</h5>
                          <p>{overviewData?.data?.avgPrimaryReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Reps Per Set</h5>
                          <p>{overviewData?.data?.avgReps?.toFixed(2)}</p>
                        </div>
                        <div className="col-md-3">
                          <h5>Average Secondary Reps</h5>
                          <p>{overviewData?.data?.avgSecondaryReps?.toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <Table responsive>
                    <thead>
                      <tr>
                        <th width="200px">Exercise</th>
                        <th>Sets</th>
                      </tr>
                    </thead>
                    <tbody>
                      {liftTrackerData?.map((item) => (
                        <tr>
                          <td>{item.exerciseName}</td>
                          <td>{item.totalSets}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default liftTrackerComponent;
